import { Injectable } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import { TwoFaService } from '@core/components-authorization-legacy';
import {
  TellentTwoFactorAuthenticationActions,
  TellentTwoFactorAuthenticationSelectors,
  // eslint-disable-next-line boundaries/element-types
} from '@core/tellent-data'; // FIXME
// eslint-disable-next-line boundaries/element-types
import type { TellentTwoFactorAuthenticationSetup } from '@core/tellent-data'; // FIXME

@Injectable({ providedIn: 'root' })
export class TellentAppTwoFaService extends TwoFaService<{ errors: string[] }> {
  constructor(
    private store: Store,
    private actions$: Actions,
  ) {
    super();
  }

  public sendSmsCode(phoneNumber: string): void {
    this.store.dispatch(
      TellentTwoFactorAuthenticationActions.sendSmsCode({ payload: phoneNumber }),
    );
  }

  public enableSmsAuth(phoneNumber: string, code: string) {
    this.store.dispatch(
      TellentTwoFactorAuthenticationActions.enableSmsAuth({
        payload: { phoneNumber, code },
      }),
    );
  }

  public enableAppAuth(code: string) {
    this.store.dispatch(
      TellentTwoFactorAuthenticationActions.enableAppAuth({
        payload: code,
      }),
    );
  }

  public getSmsSendSuccessAction(): Observable<void> {
    return this.actions$.pipe(ofType(TellentTwoFactorAuthenticationActions.sendSmsCodeSuccess));
  }

  public getSmsSendFailAction(): Observable<void> {
    return this.actions$.pipe(ofType(TellentTwoFactorAuthenticationActions.sendSmsCodeFail));
  }

  public getEnableSmsAuthFailAction(): Observable<{ payload: { error: { errors: string[] } } }> {
    return this.actions$.pipe(ofType(TellentTwoFactorAuthenticationActions.enableSmsAuthFail));
  }

  public getEnableSmsAuthSuccessAction(): Observable<void> {
    return this.actions$.pipe(ofType(TellentTwoFactorAuthenticationActions.enableSmsAuthSuccess));
  }

  public getEnableAppAuthSuccessAction(): Observable<void> {
    return this.actions$.pipe(ofType(TellentTwoFactorAuthenticationActions.enableAppAuthSuccess));
  }
  public getEnableAppAuthFailAction(): Observable<{ payload: { error: { errors: string[] } } }> {
    return this.actions$.pipe(ofType(TellentTwoFactorAuthenticationActions.enableAppAuthFail));
  }

  public selectTwoFaData(): Observable<TellentTwoFactorAuthenticationSetup> {
    return this.store.select(TellentTwoFactorAuthenticationSelectors.data).pipe(
      filterBoolean,
      filter(setup => !!setup),
    );
  }
}
